<template>
    <div class="service_provider_settled_in_from">
        <div class="tit">
          <span>
            <router-link
                to="/personal_center/service_provider/settled_in/list"
                class="back"
            >
              <i class="el-icon-arrow-left"></i>
            </router-link>服务商入驻认证
          </span>
        </div>
        <div class="body_content">
            <el-form :model="params" ref="from" label-position="top">
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            prop="name"
                            label="单位名称："
                            :rules="[{ required: true, message: '请输入“企业全称”，需与营业执照一致', trigger: 'blur' }]"
                        >
                            <el-input
                                class="input-width"
                                placeholder="请输入“企业全称”，需与营业执照一致"
                                maxlength="40"
                                show-word-limit
                                v-model="params.name"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            prop="unified_code"
                            label="统一社会信用代码："
                            :rules="[{ required: true, message: '请输入18位统一社会信用代码', trigger: 'blur' }]"
                        >
                            <el-input
                                class="input-width"
                                placeholder="请输入18位统一社会信用代码"
                                maxlength="18"
                                show-word-limit
                                v-model="params.unified_code"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item
                    label-width="170px"
                    prop="project_business_file"
                    label="营业执照扫描件："
                    :rules="[{ required: true, message: '请上传营业执照', trigger: 'blur' }]"
                >
                    <div class="myupload">
                        <div class="myupload_l">
                            <uploadFile :params="params" :apiParams="apiParams"></uploadFile>
                            <input type="hidden" v-model="params.project_business_file" />
                        </div>
                        <div class="myupload_r">
                            <p>1.请上传营业执照或法人证书的原件扫描件，或复印件加盖公章扫描件；</p>
                            <p>2.文件名格式为《单位名称-营业执照》，格式为PDF/JPG/PNG，不超过5MB。</p>
                            <p v-if="params.project_business_filePath">
                                <a
                                    target="_blank"
                                    style="color: rgb(50, 130, 255); cursor: pointer; text-decoration: underline;"
                                    :href="params.project_business_filePath"
                                    download="创始人身份证明材料"
                                >查看附件</a>
                            </p>
                            <!-- <div>
                              <el-button type="primary" size="mini" @click="viewExamples('id_card')">查看示例</el-button>
                            </div>-->
                        </div>
                    </div>
                </el-form-item>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label-width="170px"
                            prop="county" label="单位所在地区："
                            :rules="[{ required: true, message: '请选择单位所在地区', trigger: 'blur' }]"
                        >
                            <provincialSelection showCounty :provinceProp="'province'" :cityProp="'city'" :countyProp="'county'" :params="params"></provincialSelection>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label-width="170px"
                            prop="found_date"
                            label="单位注册日期："
                            :rules="[{ required: true, message: '请选择单位注册日期', trigger: 'blur' }]"
                        >
                            <el-date-picker
                                class="input-width"
                                v-model="params.found_date"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item
                    label-width="170px"
                    prop="address"
                    label="单位通信地址"
                    :rules="[{ required: true, message: '请输入单位通信地址', trigger: 'blur' }]"
                >
                    <el-input
                        type="text"
                        maxlength="120"
                        show-word-limit
                        class="input-width"
                        placeholder="请输入单位通信地址"
                        v-model="params.address"
                    ></el-input>
                </el-form-item>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label-width="170px"
                            prop="register_money"
                            label="注册资金（万元）："
                            :rules="[{ required: true, message: '请输入注册资金', trigger: 'blur' }]"
                        >
                            <el-input
                                class="input-width"
                                type="text"
                                placeholder="请输入注册资金"
                                v-model="params.register_money"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label-width="170px"
                            prop="personnel"
                            label="员工人数：">
                            <el-input
                                class="input-width"
                                type="text"
                                placeholder="请输入员工人数"
                                v-model="params.personnel"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item
                    label-width="170px"
                    prop="proposal"
                    label="公司介绍文件："
                    :rules="[{ required: true, message: '请上传公司介绍文件', trigger: 'blur' }]"
                >
                    <div class="myupload">
                        <div class="myupload_l">
                            <uploadFile :params="params" :apiParams="apiParams3"></uploadFile>
                            <input type="hidden" v-model="params.proposal" />
                        </div>
                        <div class="myupload_r">
                            <p>1.请上传单位的介绍文件，如单位介绍宣传材料；</p>
                            <p>2.文件名格式为《单位名称-单位介绍文件》，格式为PDF/RAR/ZIP，大小不超过5MB。</p>
                            <p v-if="params.proposal">
                                <a
                                    target="_blank"
                                    style="color: rgb(50, 130, 255); cursor: pointer; text-decoration: underline;"
                                    :href="params.proposalPath"
                                    download="公司介绍文件"
                                >查看附件</a>
                            </p>
                            <!-- <div>
                              <el-button type="primary" size="mini" @click="viewExamples('id_card')">查看示例</el-button>
                            </div>-->
                        </div>
                    </div>
                </el-form-item>
                <el-form-item
                    label="服务范围（多选）："
                    label-width="170px"
                    prop="service_ranges"
                    :rules="[{ required: true, message: '请选择服务范围', trigger: 'blur' }]"
                >
                    <el-checkbox-group v-model="params.service_ranges">
                        <el-checkbox v-for="(item,idx) in FNServiceRange" :key="idx" :label="item.id">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <h2>联系人信息</h2>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label-width="170px"
                            prop="founder_name"
                            label="联系人姓名："
                            :rules="[{ required: true, message: '请输入联系人姓名', trigger: 'blur' }]"
                        >
                            <el-input class="input-width" v-model="params.founder_name" placeholder="请输入联系人姓名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label-width="170px"
                            prop="founder_phone"
                            label="手机号码："
                            :rules="[{ required: true, message: '请输入手机号码', trigger: 'blur' }]"
                        >
                            <div>
                                <el-input class="input-width" v-model="params.founder_phone" disabled></el-input>
                            </div>
                            <changeMobile @receiveMobile="receiveMobile"></changeMobile>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item
                    label-width="170px"
                    prop="founder_email"
                    label="电子邮箱："
                    :rules="[{ required: true, message: '请输入电子邮箱', trigger: 'blur' }]"
                >
                    <el-input class="input-width" v-model="params.founder_email"  placeholder="请输入电子邮箱"></el-input>
                </el-form-item>
                <h2>园区选择</h2>
                <el-form-item
                    label-width="170px"
                    label="入驻园区："
                    prop="incubator"
                    :rules="[{ required: true, message: '请选择入驻园区', trigger: 'blur' }]"
                >
<!--                    <el-select-->
<!--                        v-model="params.incubator"-->
<!--                        filterable-->
<!--                        placeholder="请选择入驻园区"-->
<!--                        class="input-width"-->
<!--                    >-->
<!--                        <el-option-->
<!--                            v-for="item in restaurants"-->
<!--                            :key="item.id"-->
<!--                            :label="item.name"-->
<!--                            :value="item.id"-->
<!--                        ></el-option>-->
<!--                    </el-select>-->
                    <el-select
                        v-model="params.incubator"
                        filterable
                        remote
                        reserve-keyword
                        placeholder="请输入园区名称"
                        :remote-method="remoteMethod"
                        :loading="loading" class="input-width">
                        <el-option
                            v-for="item in restaurants"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label-width="170px" prop="project_other_file" label="其他资质证明：">
                    <div class="myupload">
                        <div class="myupload_l">
                            <uploadFile :params="params" :apiParams="apiParams2"></uploadFile>
                            <input type="hidden" v-model="params.project_other_file" />
                        </div>
                        <div class="myupload_r">
                            <p>1.请上传单位的其他资质证明；</p>
                            <p>2.文件名格式为《单位名称-其他资质证明》，格式为PDF/RAR/ZIP，不超过5MB。</p>
                            <p v-if="params.project_other_filePath">
                                <a
                                    target="_blank"
                                    style="color: rgb(50, 130, 255); cursor: pointer; text-decoration: underline;"
                                    :href="params.project_other_filePath"
                                    download="创始人身份证明材料"
                                >查看附件</a>
                            </p>
                            <!-- <div>
                              <el-button type="primary" size="mini" @click="viewExamples('id_card')">查看示例</el-button>
                            </div>-->
                        </div>
                    </div>
                </el-form-item>

                <el-form-item class="form_btm">
                    <el-button type="primary" @click="save(false)">暂存</el-button>
                    <el-button type="primary" @click="submit(true)">提交审核</el-button>
                    <el-button @click="go('settled_in');">返回</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import uploadFile from "@/components/file_upload/uploadFile.vue";
    import uploadImg from "@/components/file_upload/uploadImg.vue";
    import provincialSelection from "@/components/provincial_selection/provincial_selection.vue";
    import changeMobile from "@/components/changeMobile/change_mobile";
    import succcessfulDialog from "@/components/dialog/succcessful.vue";
    export default {
        components: {
            uploadFile,
            uploadImg,
            provincialSelection,
            changeMobile,
            succcessfulDialog
        },
        data() {
            return {
                auth: null,
                params: {
                    province: "", //省
                    city: "", //市
                    county: "", //市
                    project_other_filePath: "", //营业执照id
                    project_other_filePathPath: "", //文件路径
                    project_business_file: "", //营业执照id
                    project_business_filePath: "", //文件路径
                    service_ranges: [],
                    incubator: "",
                    entity_type: "EnterpriseEntityTypeBService"
                },
                dialogVisible3: false, //成功提示
                restaurants: [], //孵化器园区列表
                FNServiceRange: [], //孵化器园区列表
                loading: false,
                Field: [], //主营业务领域
                /** 文件上传参数*/
                apiParams: {
                    params: {
                        catalog: "CatalogActivityCover"
                    },
                    size: 5, //文件大小
                    type: "tupian|pdf", //类型
                    imgPath: "project_business_filePath", //文件路径字段
                    fileId: "project_business_file" //文件id字段
                },
                apiParams2: {
                    params: {
                        catalog: "CatalogActivityCover"
                    },
                    size: 5, //文件大小
                    type: "ysb|pdf", //类型
                    imgPath: "project_other_filePath", //文件路径字段
                    fileId: "project_other_file" //文件id字段
                },
                apiParams3: {
                    params: {
                        catalog: "CatalogActivityCover"
                    },
                    size: 5, //文件大小
                    type: "ysb|pdf", //类型
                    imgPath: "proposalPath", //文件路径字段
                    fileId: "proposal" //文件id字段
                },
            };
        },
        computed: {
            info() {
                return this.$store.state.info;
            }
        },
        created() {
            if (this.info) {
                this.getData(); /** 查询认证 用于二次编辑*/
            } else {
                this.needInfo("getData");
            }
            // this.getList();
            this.getDict("RangeServicesOther", "FNServiceRange"); //服务范围
        },
        methods: {
            // 单图截图后返回的路径和id
            uploadObj(params) {
                let obj = new Object();
                obj[params.ziduan] = params.fileId;
                obj[params.filePathfield] = params.filePath;
                this.params = Object.assign({}, this.params, obj);
            },

            /** 提交表单验证*/
            submit(type) {
                this.$refs["from"].validate(valid => {
                    if (valid) {
                        this.save(type);
                    } else {
                        this.$message.info("请检测必填项!");
                        return false;
                    }
                });
            },
            /* 监测Props */
            needInfo(name) {
                let watchAch = this.$watch("info", (val, oldVal) => {
                    if (val) {
                        this[name]();
                        watchAch(); //取消监听
                    }
                });
            },
            //远程搜索
            remoteMethod(name){
                if(name){
                    this.getList(name)
                }else{
                    this.restaurants = '';
                }
            },
            // 获取所有园区列表
            getList(name, id) {
                this.api.getIncubators({
                    name: name,
                    id: id
                }).then(res => {
                    if (res.error["err_code"] !== 0) return;
                    let list = res.obj.list || [];
                    list.forEach(item => {
                        item.value = item.name;
                    });
                    this.restaurants = list;
                });
            },
            async getData(){
                let id =
                    this.$route.query.id ||
                    sessionStorage.getItem("serviceProviderSettledId");
                if(id){
                    await this.getExtends();
                }
                await this.getEnterprises();
            },
            //查询认证扩展
            getExtends(){
              return this.api.getExtends({
                  type: "StarryExtendTypeBService",
                  id: this.$route.query.id ||
                      sessionStorage.getItem("serviceProviderSettledId")
              }).then(res=>{
                  if(res.error['err_code'] !== 0) return;
                  this.auth = res.obj.list[0];
                  this.params.id = this.auth.id;
                  this.params.incubator = this.auth.incubator;
                  console.log(this.auth)
                  this.getList('', this.auth.incubator)
              })
            },
            /** 查询认证*/
            getEnterprises() {
                this.params = Object.assign({}, this.params, {
                    founder_phone: this.info.mobile
                });
                let params = this.auth ? {
                    code: this.auth.code,
                    entity_type: "EnterpriseEntityTypeBService",
                    user_id: this.info.id
                } : {
                    entity_type: "EnterpriseEntityTypeBService",
                    user_id: this.info.id
                };
                return this.api.getEnterprises(params).then(res => {
                    if (res.error["err_code"] !== 0) return;
                    let list = res.obj.list || [];
                    let obj = list.length ? res.obj.list[0] : {};
                    if (!obj || !obj.founder_phone) {
                        obj.founder_phone = this.info.mobile;
                    }
                    obj.service_ranges = obj.service_ranges_id ? obj.service_ranges_id.split(',') : [];
                    delete obj.incubator;
                    delete obj.id;
                    this.params = Object.assign({}, this.params, obj);
                });
            },

            /** 保存表单内容*/
            save(type) {
                let operation = !type
                    ? "IdentityCertifieStatusNotSubmitted"
                    : "IdentityCertifieStatusSubmitted"; //保存或提交
                let params = Object.assign({}, this.params, {
                    operation,
                    service_ranges: this.params.service_ranges.join(',')
                });
                this.api.saveOrSubmitNBService(params).then(res => {
                    if (res.error["err_code"] !== 0) return;
                    this.$message.success("操作成功");
                    //暂存
                    if (!type) {
                        let tmpId = res.obj.id;
                        sessionStorage.setItem("serviceProviderSettledId", tmpId);
                        this.getExtends();
                    } else {
                        //提交
                        this.go("service_provider_settled_in_list");
                    }
                });
            },
            go(name) {
                this.$router.push({
                    name: name
                });
            },
            //更换手机号（子组件传值）
            receiveMobile(obj) {
                this.params = Object.assign({}, this.params, {
                    founder_phone: obj.mobile
                });
            },
            viewExamples(tmp) {
                this.viewPhoto = "";
                if (tmp === "yingye") {
                    this.viewPhoto = this.new_yinye;
                } else if (tmp === "shui") {
                    this.viewPhoto = this.shui;
                } else if (tmp === "id_card") {
                    this.viewPhoto = this.id_card_img;
                } else if (tmp === "chengluo") {
                    this.viewPhoto = this.chengluo;
                }
                this.dialogVisible = true;
            },
            //获取字典
            getDict(typeCode, key) {
                this.api
                    .getDictionaries({
                        pageSize: 999,
                        typeCode: typeCode
                    })
                    .then(res => {
                        if (res.error["err_code"] !== 0) return;
                        this[key] = res.obj.list;
                    });
            },
            // 输入搜索
            querySearch(queryString, cb) {
                var restaurants = this.restaurants;
                var results = queryString
                    ? restaurants.filter(this.createFilter(queryString))
                    : restaurants;
                console.log(results);
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            // 搜索筛选条件
            createFilter(queryString) {
                return restaurant => {
                    return (
                        restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) > -1
                    );
                };
            },
            // 选中筛选结果
            handleSelect(item) {
                this.$set(this.params, "incubator", item.id);
            }
        }
    };
</script>

<style lang="scss">
.service_provider_settled_in_from{
    h2 {
        font-size: 20px;
        font-weight: 700;
        line-height: 40px;
        span {
            font-size: 14px;
            font-weight: 500;
            margin-left: 10px;
        }
    }
    .my_cropper .rectangle .el-upload-dragger{
        width: 80px;
        height: 80px;
    }
    .form_btm {
        z-index: 999;
        text-align: center;
        position: fixed;
        bottom: 0;
        width: 100%;
        text-align: center;
        left: 0;
        right: 0;
        margin: 0 auto;
        padding: 20px 0;
        background: #fff;
        box-shadow: 0 2px 10px #999;
    }
    .tit {
        .back {
            display: inline-block;
            width: 38px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            border: 1px solid #dcdfe6;
            margin-right: 14px;
            cursor: pointer;
            vertical-align: middle;
        }
    }
}
</style>
